<template>

<v-snackbar top v-model="warningZone" :timeout=snacktimeout :color="snackcolor">
            {{ snacktext }}
</v-snackbar>

</template>

<script>

export default {

name: "LogoutTimer",

data() {
return {
events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
warningTimer: null,
logoutTimer: null,
warningZone: false,
snacktimeout: '60000',
snackcolor: '',
snacktext: '',
}
},

mounted() {
	this.events.forEach((event) => {
		window.addEventListener(event, this.resetTimer);
	}, this);

	this.setTimers();
},


destroyed() {
	this.events.forEach((event) => {
		window.removeEventListener(event, this.resetTimer);
	}, this);

	this.resetTimers();
},

methods: {
setTimers() {
	this.warningTimer = setTimeout(this.warningMessage, 7 * 60 * 60 * 1000);  //milliseconds
	this.logoutTimer = setTimeout(this.logoutUser, (7 * 60 * 60 * 1000) + 60000); //milliseconds

	//TEST 1 minture
	//this.warningTimer = setTimeout(this.warningMessage, 60 * 1000);  //milliseconds
	//this.logoutTimer = setTimeout(this.logoutUser, (60 * 1000) + 60000); //milliseconds

	this.warningZone = false;
},

warningMessage() {
	this.warningZone = true;
	this.snackcolor = 'warning';
	this.snacktext = "You will be logged off in 60 seconds due to inactivity.  Move the cursor to continue using this app.";
},

logoutUser() {
const date_now = new Date();
console.log('Logout on: ', date_now);
//document.getElementById('logout-form').click();
//document.location.href = '/' + this.app_name + '/logout';
window.location = '/logout';
},

resetTimer() {
clearTimeout(this.warningTimer);
clearTimeout(this.logoutTImer);

this.setTimers()
}

}
}
</script>
